import { H3, P2, P3 } from '../../../styles/FontStyles';
import { color } from '../../../styles/GlobalStyles';
import { useTranslation } from 'react-i18next';
import { SelectedUSDT } from '../../Marketplace/Marketplace.styled';
import {
  copyLink,
  formatUSD,
  showNetworkType,
  showTokenType
} from '../../../helpers/helperFunctions';
import { useAppSelector } from '../../../app/hooks';
import { FlexBetween } from '../../../styles/stylesStyled';
import { Icon, IconCopy } from '../../../styles/Icons';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { useHistory } from 'react-router-dom';
import { ACCOUNTING, EARNINGS } from '../../../routes/routes';

import success from '../../../assets/images/backoffice/kyc6.png';

export const OrderConfirmation = () => {
  const { t } = useTranslation('marketplace');
  const history = useHistory();
  const { userEarnbetTopup } = useAppSelector((state) => state.earnings);

  return (
    <>
      {userEarnbetTopup?.currencyType === 3 && (
        <>
          <Flexed justifyCenter>
            <img src={success} alt='success' />
          </Flexed>
          <H3 center mb='5' color={color.colors.neutral900}>
            You have successfully sent funds to Earnbet.
          </H3>
        </>
      )}

      {userEarnbetTopup?.currencyType !== 3 && (
        <div>
          <P2 mb='25' color={color.colors.neutral900}>
            To complete the transfer, please send the funds to your assigned
            wallet address below.
          </P2>
          <P2 mb='25' color={color.colors.neutral900}>
            The transfer instructions have also been sent to your email.
          </P2>
          <FlexBetween style={{ width: '100%', marginBottom: 12 }}>
            <P3 bold mb='8' color={color.colors.neutral900}>
              Transfer amount
            </P3>
          </FlexBetween>
          <SelectedUSDT>
            <div className='truncated'>
              <div>{formatUSD(userEarnbetTopup?.price)}</div>
            </div>
          </SelectedUSDT>
          <FlexBetween style={{ width: '100%', marginBottom: 12 }}>
            <P3 bold mb='8' mt='25' color={color.colors.neutral900}>
              Selected blockchain network
            </P3>
          </FlexBetween>
          <SelectedUSDT>
            <div className='truncated'>
              <div>{showNetworkType(userEarnbetTopup)}</div>
            </div>
          </SelectedUSDT>

          <FlexBetween style={{ width: '100%', marginBottom: 12 }}>
            <P3 bold mb='8' mt='25' color={color.colors.neutral900}>
              Selected Token
            </P3>
          </FlexBetween>
          <SelectedUSDT>
            <div className='truncated'>
              <div>
                {userEarnbetTopup?.networkCurrencyType
                  ? userEarnbetTopup?.networkCurrencyType
                  : showTokenType(userEarnbetTopup)}
              </div>
            </div>
          </SelectedUSDT>
          <FlexBetween style={{ width: '100%', marginBottom: 12 }}>
            <P3 bold mb='8' mt='25' color={color.colors.neutral900}>
              Wallet Address
            </P3>
          </FlexBetween>
          <SelectedUSDT
            onClick={() => {
              copyLink(userEarnbetTopup?.paymentAddress, t('success.copied'));
            }}
            style={{ cursor: 'pointer' }}>
            <div className='truncated'>
              <div>{userEarnbetTopup?.paymentAddress}</div>
            </div>

            <Icon ml='10' color={color.colors.neutral900}>
              <IconCopy />
            </Icon>
          </SelectedUSDT>
        </div>
      )}

      <Flexed justifyCenter mt='40'>
        <Button onClick={() => history.push(ACCOUNTING, { from: EARNINGS })}>
          Close
        </Button>
      </Flexed>
    </>
  );
};
